//src/pages/Buy/buyPage.js
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { RiSubtractFill } from "react-icons/ri";
import { IoMdAdd } from "react-icons/io";
import { MdVerifiedUser } from "react-icons/md";
import { TbRefresh } from "react-icons/tb";
import cart_bullet from "../../assets/images/cart_bullet.png";
import assessment from "../../assets/images/apple-touch-icon.png";
import { createOrder } from "../../api/credits/creditsApi";

const BuyPage = () => {
  const [qty, setQty] = useState(1);
  const [processing, setProc] = useState(false);
  const navigate = useNavigate();
  const user_id = localStorage.getItem("user_id");

  const benefits = [
    "Buy assessment credits in bulk so your participants can take tests without paying individually.",
    "Each credit equals one assessment attempt worth ₹10 – simple and transparent pricing.",
    "Ideal for campus drives, training programs, and hiring assessments with multiple participants.",
    "Keep the experience seamless for candidates while you centrally manage all assessment costs.",
  ];

  const handleQuantityIncrement = () => setQty((prev) => prev + 1);
  const handleQuantityDecrement = () => setQty((prev) => (prev > 1 ? prev - 1 : 1));
  const handleQuantity = (e) => setQty(Math.max(1, Number(e.target.value)));
  const handleQuantityReset = () => setQty(1);

  const discount = 0;
  const platformFee = 0;
  const totalAmount = qty * 10 + discount + platformFee;

  const handlePay = async () => {
    if (processing) return;
    setProc(true);
    try {
      const { data } = await createOrder(user_id, qty);
      window.location.href = data.checkoutUrl;
    } catch (err) {
      toast.error(err?.response?.data?.message || "Could not start payment");
      setProc(false);
    }
  };

  return (
    <div className="relative min-h-screen bg-white overflow-hidden">

      {/* <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2"></div> */}

      <style>{`
        @keyframes float {
          0% { transform: translateY(0px); }
          50% { transform: translateY(-30px); }
          100% { transform: translateY(0px); }
        }
        @keyframes float2 {
          0% { transform: translateY(0px); }
          50% { transform: translateY(30px); }
          100% { transform: translateY(0px); }
        }
        .animate-float { animation: float 8s ease-in-out infinite; }
        .animate-float2 { animation: float2 10s ease-in-out infinite; }
      `}</style>

      
      <div className="relative z-10 w-full lg:w-8/12 mx-auto flex flex-col lg:flex-row gap-6 px-3 py-6">

        
        <div className="w-full lg:w-7/12 order-2 lg:order-1">

          <h2 className="text-center text-2xl font-bold text-[#36369f] mb-4">
            Buy Assessment
          </h2>

          <div className="bg-white/70 backdrop-blur-md shadow-md border border-indigo-100 rounded-xl px-6 pt-6 pb-8 mb-6">

            
            <div className="flex flex-col sm:flex-row items-center justify-between pb-6 border-b gap-4">

              <img
                src={assessment}
                className="w-24 h-24 rounded-xl border border-indigo-100"
              />

              <div className="text-center sm:text-left">
                <h3 className="font-bold text-2xl bg-gradient-to-l from-indigo-950 to-indigo-800 bg-clip-text text-transparent">
                  My Assessment
                </h3>

                <div className="flex items-center justify-center sm:justify-start mt-3">

                  <button
                    onClick={handleQuantityDecrement}
                    className="p-2 rounded-md bg-indigo-600 hover:bg-indigo-700 text-white transition"
                  >
                    <RiSubtractFill />
                  </button>

                  <input
                    className="mx-2 w-16 text-center text-lg border border-indigo-200 rounded-md outline-indigo-400"
                    type="number"
                    min="1"
                    value={qty}
                    onChange={handleQuantity}
                  />

                  <button
                    onClick={handleQuantityIncrement}
                    className="p-2 rounded-md bg-indigo-600 hover:bg-indigo-700 text-white transition"
                  >
                    <IoMdAdd />
                  </button>
                </div>
              </div>

              <div className="text-center sm:text-right">
                <p className="font-semibold text-xl text-indigo-700">₹ 10.00</p>
                <button onClick={handleQuantityReset}>
                  <TbRefresh className="mt-2 text-red-500 hover:scale-110 transition" />
                </button>
              </div>
            </div>

            
            {benefits.map((b, i) => (
              <div key={i} className="flex items-start gap-3 py-2">
                <img src={cart_bullet} className="w-6 h-6 mt-1" />
                <p className="text-sm text-gray-700">{b}</p>
              </div>
            ))}
          </div>

          
          <button
            onClick={handlePay}
            disabled={processing}
            className={`w-full py-3 rounded-lg font-semibold transition shadow-md ${
              processing
                ? "bg-gray-500"
                : " bg-gradient-to-l from-indigo-950 to-indigo-800 text-white hover:scale-[1.02]"
            }`}
          >
            {processing ? "Processing…" : "Pay"}
          </button>
        </div>

    
        <div className="w-full lg:w-5/12 order-1 lg:order-2">

          <h2 className="text-center text-xl font-bold text-[#36369f] mb-4">
            Price Details
          </h2>

          <div className="bg-white/70 backdrop-blur-md border border-indigo-100 rounded-xl p-6 shadow-sm space-y-4">

            <div className="flex justify-between">
              <span>Price ({qty} items)</span>
              <span className="text-indigo-600 font-semibold">₹ {qty * 10}</span>
            </div>

            <div className="flex justify-between">
              <span>Discount</span>
              <span className="text-green-500 font-semibold">- ₹ 0</span>
            </div>

            <div className="flex justify-between border-y py-4 font-bold text-lg">
              <span>Total</span>
              <span>₹ {totalAmount}</span>
            </div>

          </div>

          <div className="flex items-center mt-4 gap-3">
            <MdVerifiedUser className="text-3xl text-green-600" />
            <p className="text-sm text-gray-600">
             Safe and Secure Payments.Easy returns.100% Authentic products.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyPage;